import React from 'react';
import { DatePicker, Dropdown, Input, Toggle, FileDrop } from 'app/components';
import { EVENT_TYPES } from './constants';
import { convertISOToCustomDateFormat } from '../../../utils/commonUtils';
import VenueDetails from './venueDetails';

const EventDetails = (props) => {
  const {
    eventData,
    onChange,
  } = props;

  const onUpdate = (key, value, type = null) => {
    const updated = { ...eventData };

    if (type === 'date') {
      const formattedDate = convertISOToCustomDateFormat(new Date(value).toUTCString());

      onChange({
        ...updated,
        [key]: formattedDate,
      });
    } else {
      onChange({
        ...updated,
        [key]: value,
      });
    }
  };

  return (
    <>
      <div className="event-details-form flex flex-col gap-6">
        <div className="flex gap-6 full-width">
          <Input
            className="flex-1"
            label="Event Name"
            placeholder="Enter Event Name"
            value={eventData?.name}
            onChange={(e) => onUpdate('name', e?.target?.value)}
          />
          <Input
            className="flex-1"
            label="Artist"
            placeholder="Enter Artist"
            value={eventData?.artist_name}
            onChange={(e) => onUpdate('artist_name', e?.target?.value)}
          />
          <Dropdown
            options={EVENT_TYPES}
            value={eventData?.type}
            onChange={(value) => onUpdate('type', value)}
            width={250}
            label="Event Type"
            placeholder="Select Event Type"
          />
        </div>
        <div className="flex items-end gap-6">
          <DatePicker
            disablePreviousDates={true}
            dateFormat="dd-MM-yyyy"
            selected={eventData?.start_date ? new Date(eventData?.start_date) : null}
            onChange={(date) => onUpdate('start_date', date, 'date')}
          />
          <DatePicker
            dateFormat="h:mm aa"
            label="Start Time"
            selected={eventData?.start_date ? new Date(eventData?.start_date) : null}
            showTimeSelect={true}
            showTimeSelectOnly={true}
            timeIntervals={15}
            type="time"
            onChange={(date) => onUpdate('start_date', date, 'date')}
          />
          <VenueDetails
            eventData={eventData}
            onChange={onChange}
          />
        </div>
        {/* <FileDrop
          allowedFileTypes="image/*"
          buttonText="Upload Event Image"
          onUpload={(file) => onUpdate('image', file)}
          uploadedFile={eventData?.image}
        /> */}
        <div className="flex gap-4">
          <div className="flex flex-col gap-4 items-start">
            <Input
              label="Event Image Link"
              placeholder="Event Image Link"
              width={450}
              value={eventData?.image}
              onChange={(e) => onUpdate('image', e?.target?.value)}
            />
            <Toggle
              label="This is a Trending Event"
              checked={eventData?.is_trending}
              onChange={() => onUpdate('is_trending', !eventData?.is_trending)}
            />
            <Toggle
              label="Disallow Ticket Selling"
              checked={eventData?.disallow_ticket_selling}
              onChange={() => onUpdate('disallow_ticket_selling', !eventData?.disallow_ticket_selling)}
            />
            <Toggle
              label="Community"
              checked={eventData?.is_community}
              onChange={() => onUpdate('is_community', !eventData?.is_community)}
            />
            {eventData?.is_community && 
              <Input
                label="Community Link"
                placeholder="Paste Community Link"
                width={450}
                value={eventData?.community_link}
                onChange={(e) => onUpdate('community_link', e?.target?.value)}
              />
            }
          </div>
          <img
            width={500}
            height={500}
            src={eventData?.image}
            alt="event-image-preview" />
        </div>

      </div>
    </>
  );
};

export default EventDetails;